import { IIconProps } from './icon';

export const IconPencil = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconPencil${cy}`}
    >
      <path
        d="M-0.000854492 9.64069V11.6674C-0.000854492 11.854 0.145812 12.0007 0.332479 12.0007H2.35915C2.44581 12.0007 2.53248 11.9674 2.59248 11.9007L9.87248 4.62736L7.37248 2.12736L0.0991456 9.40069C0.0324789 9.46736 -0.000854492 9.54736 -0.000854492 9.64069ZM11.8058 2.69402C12.0658 2.43402 12.0658 2.01402 11.8058 1.75402L10.2458 0.194023C9.98581 -0.0659766 9.56581 -0.0659766 9.30581 0.194023L8.08581 1.41402L10.5858 3.91402L11.8058 2.69402Z"
        fill="white"
      />
    </svg>
  );
};
